<!-- <button class="btn btn-success" (click)="next()">Next</button> -->
<!-- <router-outlet></router-outlet> -->

<app-survay-header></app-survay-header>

<div *ngIf="!qService.noSplash && (!qService.currentQuestion || !qService.currentQuestion.question_type || qService.currentQuestion.question_type == '' )">
    <app-splash></app-splash>
</div>


<div *ngIf="qService.currentQuestion.question_type">
    <div *ngIf="qService.currentQuestion.question_type == 'single-select'">
        <app-single-select></app-single-select>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'single-select-dropdown'">
        <app-single-select-dropdown></app-single-select-dropdown>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'open-end'">
        <app-open-end></app-open-end>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'multi-select'">
        <app-multi-select></app-multi-select>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'multiple-choice-single'">
        <app-multiple-choice-single></app-multiple-choice-single>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'multiple-choice-multiple-select'">
        <app-multiple-choice-multiple-select></app-multiple-choice-multiple-select>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'counter-type'">
        <app-counter-type></app-counter-type>
    </div>
    <div *ngIf="qService.currentQuestion.question_type == 'complete'">
        <app-thank-you></app-thank-you>
    </div>
</div>